"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarDatePicker = void 0;
var tslib_1 = require("tslib");
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var padding_1 = require("../padding");
var header_1 = (0, tslib_1.__importDefault)(require("./components/header"));
var month_1 = (0, tslib_1.__importDefault)(require("./components/month"));
var calendar_1 = require("./hooks/calendar");
function CalendarDatePicker(props) {
    var onChange = props.onChange, value = props.value, validate = props.validate, maxDate = props.maxDate, minDate = props.minDate;
    var maxYear = maxDate === null || maxDate === void 0 ? void 0 : maxDate.getYear();
    var minYear = minDate === null || minDate === void 0 ? void 0 : minDate.getYear();
    var today = string_formatters_1.CalendarDate.today();
    var calendar = (0, calendar_1.useCalendar)({
        initialVisibleMonth: value ? value.getMonth() : today.getMonth(),
        initialVisibleYear: value ? value.getYear() : today.getYear(),
    });
    return (react_1.default.createElement("div", { style: { width: 224 } },
        react_1.default.createElement(padding_1.Padding, { bottom: 8 },
            react_1.default.createElement(header_1.default, { calendarHook: calendar, minYear: minYear, maxYear: maxYear })),
        react_1.default.createElement(month_1.default, { calendarHook: calendar, onClick: onChange, validate: validate, selectedDate: value })));
}
exports.CalendarDatePicker = CalendarDatePicker;
//# sourceMappingURL=index.js.map